<div class="container-fluid full-page-height">
    <div class="d-flex justify-content-center flex-wrap banner-container">
        <div class="banner-content">
            <div class="banner-text">
                <p> Manage QR Codes </p>
                <p class="description">
                    {{ 'HomeDescription' | translate}}
                </p>
                <button mat-raised-button color="primary" (click)="goToGenerateQR()">{{'GenerateActivationCodes' | translate }}</button>
            </div>
            <div class="banner-logo">
                <img src="assets/img/pump_icon_banner.svg" alt="App Logo"/>
            </div>
        </div>
    </div>
    <!-- <div class="pt-3 home-card-container">
        <h3 class="mt-2 mb-2 position-relative">{{'ServicesView' | translate}}
            <mat-icon class="info ml-auto ml-1" [popover]="popTemplate" [outsideClick]="true" [adaptivePosition]="false"
                placement="right">info</mat-icon>
            <ng-template #popTemplate>
                <div>
                    <div class="col">
                        <div class="p-2 h-200"> {{'ServicesText' | translate}}

                        </div>
                    </div>
                </div>
            </ng-template>
        </h3>
        <div class="d-flex AUadmin-card-container row flex-wrap pt-2 " cdkDropListGroup>
            <div class="cursor  col-xl-4 col-lg-4 col-md-12 col-xs-12">
                <div class="suport-card">
                    <h3 class="d-flex align-items-end m-0 font-weight-bold">{{'Help and Support' | translate}}</h3>
                </div>
            </div>
        </div>
    </div>
    <div>
        <div class="home-card-container">
            <h3 class="mt-1 position-relative">{{'MyShortcuts' | translate}}
                <mat-icon class="info ml-auto ml-1" [popover]="popTemplate1" [outsideClick]="true"
                    [adaptivePosition]="false" placement="right">info</mat-icon>
                <ng-template #popTemplate1>
                    <div>
                        <div class="col">
                            <div class="p-2 h-200"> {{'MyShortcutstext' | translate}}


                            </div>
                        </div>
                    </div>
                </ng-template>
            </h3>

            <div class="row flex-wrap">
                <div class=" col-xl-2 col-lg-2 col-md-4 col-xs-12" routerLink="tasks" id="my-task" *ngIf="isAccess">
                    <div class="cursor dashboard-card-container">
                        <div class="d-flex justify-content-center dashadmin-container p-3 mb-2">
                            <img class="assets-icon-hover" src="assets/img/svg/app-manager/my-task-hover.svg" />
                            <img class="assets-icon" src="assets/img/svg/app-manager/my-task.svg" />
                        </div>
                        <div>
                            <p class="semi-bold shortcut-name mb-0 mt-2">{{'MyTasks' | translate}}</p>
                            <p class="line-h-16 mt-1 m-0">
                                <small>{{'MyTaksMsg' | translate}}</small>
                            </p>
                        </div>
                    </div>
                </div>
                <div class="col-xl-2 col-lg-2 col-md-4 col-xs-12" id="{{pinnedApp.name}}"
                    *ngFor="let pinnedApp of pinnedApps;let i = index" (click)="appClickAction(pinnedApp)">
                    <div class="cursor dashboard-card-container">
                        <div class="d-flex justify-content-center dashadmin-container p-3 mb-2">
                            <img class="assets-icon-hover" src="{{pinnedApp?.iconHoverUrl}}" />

                            <img class="assets-icon" src="{{pinnedApp?.iconUrl}}" />

                        </div>
                        <p class="semi-bold mb-0 shortcut-name  mt-2">{{pinnedApp?.name}}</p>
                        <p class="line-h-16 m-0 mt-1">
                            <small>{{pinnedApp?.description}}</small>
                        </p>
                        <img title="Remove from shortcut" class="aterial-icons ssets-icon-hover favorite-img cursor"
                            (click)="removeFromDashbord(pinnedApp.pinToDashboardId, i,$event)"
                            src="assets/img/icons/un_pin.svg" />
                    </div>
                </div>
                <div style="opacity:.5" id="{{short}} +'_'  + {{j}}" *ngFor="let short of shortCutArray;let j=index;"
                    class="col-xl-2 col-lg-2 col-md-4 col-xs-12 manage-div d-flex align-items-center">

                    <div class="cursor dash-container d-flex align-items-center text-center">
                        <div class="align-self-center w-100">
                            <img class="pinassets-icon" src="assets/img/icons/un_pin.svg" />
                            <p class=" m-0 ml-3 mr-3">
                                <small>{{'shortcutAlert' | translate}}</small>
                            </p>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div> -->
</div>
<div class="copyright-home mt-1 mb-3 text-center">
    <p>
        <span class="cursor" (click)="consentView('')">{{'privacyNotice' | translate}} </span> | {{'CopyrightMsg' |
        translate}}
    </p>
</div>